module.exports = __webpack_public_path__ + "img/calendar3.7376f525.png";